import { REF_DATA, SELECTED_COUNTRY, COUNTRIES, RESET } from '../constants'

export const referenceData = referenceData => ({
  type: REF_DATA,
  referenceData
})

export const selectedCountry = country => ({
  type: SELECTED_COUNTRY,
  country
})

export const listOfCountries = countries => ({
  type: COUNTRIES,
  countries
})

export const reset = () => ({
  type: RESET,
  undefined
})



// WEBPACK FOOTER //
// ./src/actions/referenceData.js